module.exports = "<div class=\"status m-top-0\"\n  [ngClass]=\"classes\">\n  {{ message }}\n</div>\n";